import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes/index'

export const Container = styled.div<{ isRowHeader: boolean; withCursor: boolean }>`
  height: 100%;
  width: 100%;
  cursor: ${({ withCursor }) => (withCursor ? 'text' : 'default')};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  > div {
    color: ${({ isRowHeader }) => (isRowHeader ? colors.white : colors.darkBlue500)};
  }
`

export const Placeholder = styled.div`
  position: absolute;
`

export const TextArea = styled.div<{ maxLines: number; focused: boolean }>`
  max-height: 100%;
  width: 100%;
  outline: none;
  text-align: center;
  overflow: hidden;
  line-height: 17px;

  ${({ focused, maxLines }) =>
    !focused &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: ${maxLines};
      -webkit-box-orient: vertical;
    `}
`
